import React from 'react';
import { Surface } from 'react-native-paper';
import { useRoute } from '@react-navigation/native';
import styled from 'styled-components/native';

import Container from '@src/components/Container';
import RefreshControl from '@src/components/RefreshControl';
import Separator from '@src/components/Separator';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { Rank } from '@src/types';

import RankAvatar from './RankAvatar';
import RankCard from './RankCard';
import { List } from './styled';
import useBoard from './useBoard';

const Header = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Screen: React.FC = () => {
  const route = useRoute();
  const type = React.useMemo(() => {
    switch (route.name) {
      case 'Friends':
        return 'friends';
      case 'Monthly':
        return 'monthly';
      case 'All':
      default:
        return 'all';
    }
  }, [route.name]);
  const { list, rank } = useBoard(type);

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          ListHeaderComponent={
            <Header>
              <RankAvatar index={2} item={list.data[1]} size={48} />
              <Separator />
              <RankAvatar index={1} item={list.data[0]} size={84} />
              <Separator />
              <RankAvatar index={3} item={list.data[2]} size={48} />
            </Header>
          }
          data={list.data.slice(3)}
          refreshControl={
            <RefreshControl
              refreshing={list.refreshing}
              onRefresh={list.handleRefresh}
            />
          }
          onEndReached={list.handleEndReached}
          renderItem={({ item, index }: { item: Rank; index: number }) => (
            <RankCard index={index + 4} item={item} />
          )}
        />
        {rank && (
          <Surface>
            <RankCard index={rank.index} item={rank} />
          </Surface>
        )}
      </Container>
    </>
  );
};

Screen.displayName = 'Board';

export default Screen;
